import { Request } from '@/classes/Request.ts'
import { Util } from '@/modules/util'

export const menuCalendar = async (studentAccountId: string, startDate: Date, endDate: Date) => {
  const formattedStartDate = startDate ? startDate.toISOString().split('T')[0] : null
  const formattedEndDate = endDate ? endDate.toISOString().split('T')[0] : null
  const params = {
    student_account_id: studentAccountId,
    start_date: formattedStartDate,
    end_date: formattedEndDate
  }
  const response = await new Request().get('/ajax/menu', params)
  return Util.Obj.keysToCamel(response.data)
}
